import { lazy } from "react";

/**
 * React.lazy plus a preload hook. Used for code-split routes so index.js can load the current route's chunk
 * BEFORE the first render: once preloaded, the lazy factory returns a synchronous thenable, React resolves the
 * component immediately, and a prerendered page is replaced in one commit with no "Loading..." flash.
 */
export function lazyRoute(importer) {
  let loaded = null;
  const load = () => importer().then((mod) => { loaded = mod; return mod; });
  const Component = lazy(() => (loaded ? { then: (resolve) => resolve(loaded) } : load()));
  Component.preload = load;
  return Component;
}
